var gql = require("@apollo/client").gql;

const RATING_TABLE_QUERY = gql`
	query inMainRating($filter: String, $inMainRating: Int!, $sort: String) {
		providers(filter: $filter, in_main_rating: $inMainRating, limit: 30, sort: $sort) {
			data {
				id
				name
				url_name
				logo
				info {
					cnt_tariffs
				}
				rating {
					order_types {
						review_all
						order_type_id
						rating
						rating_plus
						rating_minus
						rating_middle
						provider_answer_count
					}
				}
			}
		}
	}
`;

export default RATING_TABLE_QUERY;
